module.exports = __webpack_public_path__ + "media/images/icons/user-tie-b3bdfff2e17b767123776b260c6e1140.svg";